import { Link } from '@mui/material';
import theme from 'library/theme/theme';
import styled from 'styled-components';

export const LinkWrapper = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing(0.5)};
`;
